// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  encryptedToken: 'c8a9ce008ee53e9e563807c8546c3e07edb2d614b9d8439d984efe51027c23603b14d8d1e18d1e711bbd231dad00f3fe',
  key: '8786118b0d91aa06b722c3af5a106e6baf271c473ec9ece487afd636b04e09b2',
  iv: '9075cdfc2c2bd9c952153784397772a4'
  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
